exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".script-view-content{min-height:var(--script-view-section-min-height)}.script-view-metadata{justify-content:space-between;float:bottom}.script-view-metadata-icon{padding-right:10px}.script-view-metadata-component{text-align:center}.script-view-metadata-component:first-child{text-align:left}.script-view-metadata-component:last-child{float:right}", ""]);

// exports
